import "../index.css";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import { PageNav } from "../components/PageNav";
import { Selfie1, Selfie2 } from "../components/Logo";

export default function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <PageNav />
      <div className="bsp-page">
        <div className="bsp-section bsp-container-narrow bsp-center font_family_base">
          <div className="bsp-eyebrow">About BStrong Performance</div>
          <h1 className="bsp-h1">
            If You're Carrying the Weight of Leadership, You're in the Right
            Place
          </h1>
          <p className="bsp-lead">
            BStrong Performance specializes in personal leadership behavior,
            team dynamics, and organizational alignment via people-oriented
            systems and functions.
          </p>
        </div>

        <div className="bsp-section bsp-container font_family_base">
          <div
            style={{
              display: "flex",
              gap: 48,
              alignItems: "flex-start",
              flexWrap: "wrap",
            }}
          >
            <div style={{ width: 280, flexShrink: 0, margin: "0 auto" }}>
              <Selfie2 />
            </div>
            <div style={{ flex: 1, minWidth: 280 }}>
              <h2 className="bsp-h2">Brian A. Armstrong, Ph.D., CPCC</h2>
              <div
                className="bsp-eyebrow"
                style={{ marginTop: -8, marginBottom: 20 }}
              >
                Founder &amp; Principal Consultant
              </div>
              <ul className="bsp-list">
                <li>
                  Dr. Brian A. Armstrong brings professional certifications,
                  academic degrees, and a broad level of experience to
                  leadership engagements from C-Suite executives, new-to-role,
                  and emerging leaders.
                </li>
                <li>
                  He is a certified facilitator, credentialed in a variety of
                  assessment tools (MBTI, Hogan, Insights, EQ-i 2.0, Risk Type
                  Compass, etc.), with thousands of facilitation, coaching,
                  and engagement hours spanning a career of corporate roles,
                  private consulting, and higher-education.
                </li>
                <li>
                  Brian brings nearly three decades of leadership development
                  and coaching, originally co-founding BStrong Performance in
                  2005.
                </li>
                <li>
                  BStrong Performance specializes in personal leadership
                  behavior, team dynamics, and organizational alignment via
                  people-oriented systems and functions.
                </li>
              </ul>
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  flexWrap: "wrap",
                  marginTop: 24,
                }}
              >
                {[
                  {
                    label: "Co-Active Coaches Training Institute",
                    href: "https://coactive.com/",
                  },
                  {
                    label: "Myers-Briggs",
                    href: "https://www.themyersbriggs.com/",
                  },
                  { label: "MHS", href: "https://mhs.com/" },
                ].map((cred) => (
                  <a
                    key={cred.label}
                    href={cred.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bsp-eyebrow"
                    style={{
                      border: "1px solid rgba(59,130,246,0.35)",
                      borderRadius: 999,
                      padding: "8px 16px",
                      marginBottom: 0,
                      textDecoration: "none",
                    }}
                  >
                    {cred.label}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="bsp-section-narrow bsp-container-narrow font_family_base">
          <div className="bsp-card-alt">
            <p className="bsp-quote">
              Leadership isn't about having all of the answers, but staying
              balanced and strategic in times of change.
            </p>
          </div>
        </div>

        <div className="bsp-section bsp-container font_family_base">
          <div
            style={{
              display: "flex",
              gap: 48,
              alignItems: "flex-start",
              flexWrap: "wrap-reverse",
            }}
          >
            <div style={{ flex: 1, minWidth: 280 }}>
              <h2 className="bsp-h2">My Story</h2>
              <p className="bsp-body" style={{ marginBottom: 16 }}>
                I began my professional efforts within education and quickly
                transitioned into management and consulting roles. I
                continued my professional development through classroom study
                and a broad Fortune 200 corporate experience.
              </p>
              <p className="bsp-body" style={{ marginBottom: 16 }}>
                In each role, I always felt that I was an outsider, asking
                questions to understand the <em>why's</em> behind leadership,
                the <em>value</em> of activities, and the <em>alignment</em>{" "}
                between intention and impact.
              </p>
              <p className="bsp-body" style={{ marginBottom: 16 }}>
                Ultimately, I blend a background in education, business
                experience, and advanced studies in leadership, management,
                and organizational culture &mdash; bridging the gap between
                management operations and individual development.
              </p>
              <p className="bsp-body" style={{ marginBottom: 16 }}>
                Each of these experiences has honed my own approach to
                leadership, grounded in a framework <em>identifying what is
                out of balance</em>, intentionally setting a{" "}
                <em>strategic path toward a desired future</em>, understanding
                the <em>transformation that needs to occur</em>, embracing the{" "}
                <em>responsibility, accountability, and authority</em> to
                lead through the process, <em>organizing people and processes</em>{" "}
                toward success, building on <em>natural strengths and
                capabilities</em>, and <em>setting goals measured by their
                impact</em> on their intended balancing efforts.
              </p>
              <p className="bsp-body">
                This is why I coach; to continue a professional journey of
                service that began in the classroom, continued through
                training and development, and by supporting leaders who have
                great responsibility and impact inside, through, and beyond
                their organizations and who are often alone during their
                journey.
              </p>
            </div>
            <div style={{ width: 260, flexShrink: 0, margin: "0 auto" }}>
              <Selfie1 />
            </div>
          </div>
        </div>

        <div className="bsp-section-narrow bsp-container-narrow bsp-center font_family_base">
          <div className="bsp-card">
            <div className="bsp-eyebrow">Read the Research</div>
            <h2 className="bsp-h2">BSP Bookshelf</h2>
            <p className="bsp-body" style={{ marginBottom: 20 }}>
              Brian's doctoral dissertation is available now, with his
              forthcoming book, <em>The BStrong Leadership Framework</em>,
              coming soon.
            </p>
            <Link to="/bookshelf" className="bsp-btn bsp-btn-outline">
              Visit the Bookshelf
            </Link>
          </div>
        </div>

        <div className="bsp-section bsp-cta-band bsp-center font_family_base">
          <h2 className="bsp-h2">Let's Work Together</h2>
          <p className="bsp-lead" style={{ marginBottom: 8 }}>
            See how a coaching engagement with BStrong Performance could fit
            your goals.
          </p>
          <div className="bsp-hero-actions">
            <Link to="/services" className="bsp-btn bsp-btn-outline">
              View Services
            </Link>
            <Link to="/contact" className="bsp-btn bsp-btn-primary">
              Get In Touch
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
